import * as React from 'react';
import styles from './index.less';
import { observer } from 'mobx-react';
import cx from 'classnames';

/**
 * 弹窗容器
 * 用于所有的需要使用useModal的弹窗中, 包裹了之后,会自动补充入场和出场的动效, 及绝对的居中定位
 * @param modalState
 * @param children
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 *
 * example:
 * <ModalContainer modalState={store.isOpen}>
 *  {...弹窗原本的内容, 弹窗的样式记得改成position: relative, 容器会自适应居中 }
 * </ModalContainer>
 *
 * PS: 弹窗的store需要继承BaseModalStore
 * example:
 * class demoModalStore extends BaseModalStore
 *
 */
const ModalContainer = ({ modalState, children, onMaskClick, ...rest }) => {
  return (
    <div className={cx(styles.modalContainer, modalState && styles.openModal)} {...rest}>
      <div className={styles.mark} onClick={onMaskClick} />
      <div className={cx(styles.containerBody)} onClick={event => event.stopPropagation()}>
        {children}
      </div>
    </div>
  );
};

export default observer(ModalContainer);
